import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7Preloader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7Preloader, _React$Component);

  function F7Preloader(props, context) {
    var _this;

    _classCallCheck(this, F7Preloader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7Preloader).call(this, props, context));

    _this.state = function () {
      var self = _assertThisInitialized(_assertThisInitialized(_this));

      var $f7 = self.$f7;

      if (!$f7) {
        self.$f7ready(function () {
          self.setState({
            _theme: self.$theme
          });
        });
      }

      return {
        _theme: $f7 ? self.$theme : null
      };
    }();

    return _this;
  }

  _createClass(F7Preloader, [{
    key: "render",
    value: function render() {
      var self = this;
      var sizeComputed = self.sizeComputed,
          props = self.props;
      var id = props.id,
          style = props.style,
          className = props.className;
      var theme = self.state._theme;
      var preloaderStyle = {};

      if (sizeComputed) {
        preloaderStyle.width = "".concat(sizeComputed, "px");
        preloaderStyle.height = "".concat(sizeComputed, "px");
        preloaderStyle['--f7-preloader-size'] = "".concat(sizeComputed, "px");
      }

      if (style) Utils.extend(preloaderStyle, style || {});
      var innerEl;

      if (theme && theme.md) {
        innerEl = React.createElement('span', {
          className: 'preloader-inner'
        }, React.createElement('span', {
          className: 'preloader-inner-gap'
        }), React.createElement('span', {
          className: 'preloader-inner-left'
        }, React.createElement('span', {
          className: 'preloader-inner-half-circle'
        })), React.createElement('span', {
          className: 'preloader-inner-right'
        }, React.createElement('span', {
          className: 'preloader-inner-half-circle'
        })));
      } else if (theme && theme.ios) {
        innerEl = React.createElement('span', {
          className: 'preloader-inner'
        }, React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }), React.createElement('span', {
          className: 'preloader-inner-line'
        }));
      } else if (theme && theme.aurora) {
        innerEl = React.createElement('span', {
          className: 'preloader-inner'
        }, React.createElement('span', {
          className: 'preloader-inner-circle'
        }));
      } else if (!theme) {
        innerEl = React.createElement('span', {
          className: 'preloader-inner'
        });
      }

      var classes = Utils.classNames(className, 'preloader', Mixins.colorClasses(props));
      return React.createElement('span', {
        id: id,
        style: preloaderStyle,
        className: classes
      }, innerEl);
    }
  }, {
    key: "sizeComputed",
    get: function get() {
      var s = this.props.size;

      if (s && typeof s === 'string' && s.indexOf('px') >= 0) {
        s = s.replace('px', '');
      }

      return s;
    }
  }]);

  return F7Preloader;
}(React.Component);

__reactComponentSetProps(F7Preloader, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  size: [Number, String]
}, Mixins.colorProps));

F7Preloader.displayName = 'f7-preloader';
export default F7Preloader;